// DS: C33A
/** Bottom section of a thumb, containing related information */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiUser, PapiDeviation } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import DeviationLink from '../Duperbrowse/DeviationLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './ThumbInfo.scss';

export interface Props {
  user: PapiUser;
  urlDeviation: PapiDeviation;
  title?: string;
}

const AVATAR_SIZE_DESKTOP = 32;
const AVATAR_SIZE_MOBILE = 24;

const ThumbInfo: React.FC<React.PropsWithChildren<Props>> = ({ user, title, urlDeviation }) => {
  const isMobile = useContext(MobileContext);
  return (
    <div className={classnames(s['root'], title ? s['with-title'] : s['without-title'])}>
      {(!title || !isMobile) && (
        <UserAvatar
          size={isMobile ? AVATAR_SIZE_MOBILE : AVATAR_SIZE_DESKTOP}
          user={user}
          className={s['avatar']}
        />
      )}

      {!title && (
        <UserLink
          user={user}
          className={s['username']}
          biData={{
            creatorid: user.useridUuid,
          }}
        />
      )}

      {title && (
        <div className={s['info']}>
          <DeviationLink className={s['title']} deviation={urlDeviation}>
            {title}
          </DeviationLink>
          <Flex className={s['secondRow']} alignItems="center">
            {isMobile && (
              <UserAvatar size={AVATAR_SIZE_MOBILE} user={user} className={s['avatar']} />
            )}
            <UserLink
              user={user}
              className={s['username']}
              biData={{
                creatorid: user.useridUuid,
              }}
            />
          </Flex>
        </div>
      )}
    </div>
  );
};
ThumbInfo.displayName = 'ThumbInfo';

export default ThumbInfo;
